import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { CxTableService } from '../services/cx-table.service';

@Directive({
  selector: '[cxSelectionColumn]'
})
export class ColumnSelectionDirective implements OnInit {
  @Input() cxSelectionColumn: any = null;
  @Input() cxSelectionColumnRow: any = null;
  @Input() isSelectAll: boolean = false;

  constructor(private el: ElementRef, private tableServive: CxTableService) {
    this.el.nativeElement.onclick = () => {
      if (this.isSelectAll) {
        this.cxSelectionColumn.selected = !this.cxSelectionColumn.selected;
        this.tableServive.$selection.next({ type: 'column', data: this.cxSelectionColumn  });
      } else {
        this.cxSelectionColumnRow.selected = !this.cxSelectionColumnRow.selected;
        this.tableServive.$selection.next({ type: 'row', data: this.cxSelectionColumnRow  });
      }
    }
  }
  ngOnInit(): void {}
}